import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Modal,
	Grid,
	Chip,
	TextField,
	InputAdornment,
	IconButton,
	Table,
	TableHead,
	TableRow,
	TableContainer,
	TableCell,
	TableBody
} from '@mui/material';
import { useEffect, useMemo, useState , useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import ApiService from '../../functions/apiService';
import { RotationTableModal } from './RotationTableModal';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Row , Col } from 'react-bootstrap';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
import moment from 'moment';
import AuthContext from '../../context/AuthContext';

export const RotationTable = ({
  positions,
  shifts = [],
	onExpandChange,
	open
}) => {
  const [params] = useSearchParams();
  const dateParam = params.get('date') || new Date().toISOString().split('T')[0];
	const { user } = useContext(AuthContext);
  const [rotationData, setRotationData] = useState([]);
  const [isRotationDataLoading, setIsRotationDataLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editUser, setEditUser] = useState('');
	const [editData , setEditData] = useState([]);
	const [deleteModal , setDeleteModal] = useState(false);
	const [deleteData , setDeleteData] = useState([]);
	const [loading , setLoading] = useState(false);
	const [assignModal , setAssignModal] = useState(false);
	const [hitListEmployees , setHitListEmployees] = useState([]);
	const [search , setSearch] = useState('');
	const [confirmAssignModal , setConfirmAssignModal] = useState(false);
	const [selectedEmpData , setSelectedEmpData] = useState([]);
	const [hitListData , setHitListData] = useState([]);

  const refactoredPositions = useMemo(() => {
    return positions.map((item) => ({
      code: item.SO_Value,
      fullName: item.SO_Desc,
    }));
  }, [positions]);
	

	const columns = [
		{
			field: 'assignmentCode',
			headerName: 'Assignment',
			flex: 1,
		},
		{
			field: 'name',
			headerName: 'Name',
			flex: 1,
			renderCell: (params) => (
				<div style={{paddingLeft:'30px' , display:'flex' , justifyContent:'space-between' , alignItems:'center' , width: '100%',}}>
					<p style={{paddingTop:'16px'}}>{params.row.rank || ''} {params.row.name || ''}</p>
					{params?.row?.absentData &&
						<Chip 
							style={{
								padding:'6px 10px' ,
								marginLeft:'10px',
								display:'flex',
								justifyContent:'end',
								backgroundColor : 
									params?.row?.absentData?.Status	 === 'F' ? '#079e46' : 
									params?.row?.absentData?.Status	 === 'Q' ? '#FFA500' :
									params?.row?.absentData?.Status	 === 'D' ? '#000000' :
									'#e62719',
								color: params?.row?.absentData?.Status	 === 'Q' ? '#000000' :'#ffffff'
							}} 
							label = {
								params?.row?.absentData?.Status	 === 'F' ? 
								`${params?.row?.absentData?.absent_code?.SO_Desc} (${params?.row?.absentData?.filled_employee?.employee?.fullName})` : 
								params?.row?.absentData?.absent_code?.SO_Desc
							} 
						/>
					}
				</div>
			),
		},
		{
			field: 'shifts',
			headerName: 'Shift Type',
			flex: 1,
			align: 'left',
			headerAlign: 'left',
			renderCell: (params) => (
				<Chip 
					style={{
						marginLeft:'55%' , 
						padding:'10px 10px' ,
						width:'100px',
						backgroundColor : params.row.shifts  === 'Day' ? '#ffa50042' : '#3498db29',
						border: params.row.shifts  === 'Day' ? '1px solid  #ffa50047' : '1px solid #3498db33',
					}} 
					label = {params.row.shifts || ''} 
				/>
			),
		},
		{
			field: 'edit',
			headerName: 'Actions',
			flex: 0.5,
			sortable: false,
			filterable: false,
			align: 'right',
			headerAlign: 'right',
			renderCell: (params) => (
				<div>
					{params?.row?.absentData?.length == 0 || params?.row?.absentData?.Status == 'F' ? '' : 
						<img
							src="/images/overtime2.svg"
							width={28}
							height={28}
							style={{ cursor: 'pointer', alignSelf: 'center' , marginRight:'6px' }}
							onClick={() => {
								setAssignModal(true)
								getEmployeeList(params?.row)
								setHitListData(params?.row)
							}}
						/>
					}
					{params?.row?.absentData?.length == 0  ? 
						<EditIcon onClick={() => onEditClick(params.row.id , params.row)} sx={{color:'#555555' , cursor:'pointer' , fontSize:'20px'}}/>
 						: ''
					}
					{params?.row?.absentData &&
						<DeleteIcon sx={{color:'#555555' , cursor:'pointer' , fontSize:'20px' , marginLeft:'6px'}} onClick={() => onDeleteClick(params?.row?.absentData)} />
					}
				</div>
			),
		},
	];

	const getEmployeeList = (data) => {
		setLoading(true)
		const body = {
			"Shift_Date": data?.absentData?.Shift_Date,
			"Shift_Code": data?.absentData?.Shift_Code,
		}
		ApiService.post('/volunteerHitListRotation', body)
			.then((data) => {
				setLoading(false);
				setHitListEmployees(data?.employees || [])
			})
			.catch(() => {
				console.error('error')
				setLoading(false);
			})
	}

	const filteredEmployees = hitListEmployees?.filter((emp) =>
		emp?.fullName?.toLowerCase().includes(search.toLowerCase())
	);
  
	const refactoredShifts = useMemo(() => {
		if(shifts.length === 0) return []

		return shifts.map((item) => ({
			startTime: item.Start_Time,
			endTime: item.End_Time,
			title: item.Short_Desc,
			shiftCode: item.ShiftCode
		}))
	}, [shifts])

  const toggleModalOpen = () => setIsEditModalOpen((p) => !p);
	const toggleModalDeleteOpen = () => setDeleteModal((p) => !p);

  const onEditClick = (empId , data) => {
		setEditData(data)
    setEditUser(empId);
    toggleModalOpen();
  };

	const onDeleteClick = (data) => {
    setDeleteData(data);
    toggleModalDeleteOpen();
  };

	const getRotationData = async () => {
		try {
			setIsRotationDataLoading(true);
			const { data } = await ApiService.get(
				'/getAlternateScheduleEmpsWorking',
				{
					date: dateParam,
				}
			);
			setRotationData(
				Object.values(data.Emps_Working).map((item) => ({
					name: item.Emp.fullName,
					emp: item.Emp.Emp_Code,
					shifts: item.Shifts.map((shiftCode) => {
						const shiftInfo = refactoredShifts.find((shift) => Number(shift.shiftCode) === Number(shiftCode))
						if(!shiftInfo) return 'No shift with that code'
						return shiftInfo.title
					}).join(', '),
					shift_Code: item.Shifts.map((shiftCode) => {
						const shiftInfo = refactoredShifts.find((shift) => Number(shift.shiftCode) === Number(shiftCode))
						if(!shiftInfo) return 'No shift with that code'
						return shiftInfo.shiftCode
					}),
					assignmentCode:
						refactoredPositions.find(
							(pos) => pos.code == item.Emp.Position_Code
						).fullName || 'No such position found',
					rank: item.Emp.EA_Rank,
					absentData : item.Overtime,
				}))
			);
			setIsRotationDataLoading(false);
		} catch (error) {
			console.error(error);
			setIsRotationDataLoading(false);
		}
	};

  useEffect(() => {
    getRotationData();
  }, [dateParam, refactoredPositions, refactoredShifts]);

	const rows = rotationData.map((row, index) => ({
		id: index,
		...row,
	}));

	let deleteShift = (data) => {
		ApiService.delete(`/deleteEmployeesOvertime?ShiftNumber[]=${data?.Shift_Number}&FillEmp=false&type=${data?.Absent_Code}&date=${data?.Shift_Date}`)
			.then((data) => {
				setDeleteModal(false)
				toast.success('Shift deleted Successfully');
				getRotationData();
			}
		)
	};

	const assignShift = (data) => {
		const body = {
			Shift_Date: hitListData?.absentData?.Shift_Date,
			Shift_Number: hitListData?.absentData?.Shift_Number,
			Emp_Code: String(data?.Emp_Code),
		};
		ApiService.post('/rotationFillOvertime', body)
			.then((data) => {
				getRotationData()
				toast.success(data?.message)
				setConfirmAssignModal(false)
				setAssignModal(false)
			})
			.catch((err) => {
				toast.error(err?.data?.message || 'Error')
				setConfirmAssignModal(false)
				setAssignModal(false)
			})
	}

  return (
    <>
      {rotationData.length > 0 ? (
        <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2}} elevation={0}>
          <Modal
            open={isEditModalOpen}
            onClose={toggleModalOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                width: '800px',
                backgroundColor: 'white',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: 2,
              }}
            >
              <RotationTableModal
                employeeInfo={editUser}
                toggleModal={toggleModalOpen}
                shiftsInfo={refactoredShifts}
								editData = {editData}
								getRotationData = {getRotationData}
              />
            </Box>
          </Modal>

					<Modal
            open={deleteModal}
            onClose={toggleModalDeleteOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                width: '400px',
                backgroundColor: 'white',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: 4,
              }}
            >
              <div>
								<h5 className='mb-3'>Are u sure to delete this Shift ?</h5>
							</div>
							<Row>
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
										Cancel
									</ButtonTheme>
								</Col>
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => deleteShift(deleteData)}>
										Delete
									</ButtonTheme>
								</Col>
							</Row>
            </Box>
          </Modal>
          <Typography sx={{ fontSize:'18px !important' , fontWeight:'600' , paddingLeft:'8px'}}>
            Alternate Schedules
          </Typography>
          {isRotationDataLoading ? (
            <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
              <CircularProgress />
            </Box>
          ) : (
						<Grid container>
							<Grid md={9} sm={9} lg={9} sx={{ pr: 1 }}>
								<CollapseComponent
									name={'Position'}
									rows={rows}
									columns={columns}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							</Grid>
						</Grid>
          )}
        </Paper>
      ) 
      : 
      ""
      // (
      //   <Box
      //     sx={{
      //       display: 'flex',
      //       justifyContent: 'center',
      //       alignItems: 'center',
      //       minHeight: '300px',
      //     }}
      //   >
      //     <Typography variant="h3" fontWeight={800}>
      //       No data
      //     </Typography>
      //   </Box>
      // )
      }

			<Modal
				open={assignModal}
				onClose={() => setAssignModal(false)}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						width: '700px',
						backgroundColor: 'white',
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						padding: 4,
						borderRadius: '8px',
						boxShadow: 24,
					}}
				>
					<CloseIcon
						onClick={() => setAssignModal(false)}
						sx={{
							position: 'absolute',
							top: 20,
							right: 29,
							cursor: 'pointer',
							color: '#555',
							'&:hover': { color: '#000' },
						}}
					/>

					<div>
						<h5 className="mb-3">Available personnel</h5>
					</div>

					<TextField
						variant="outlined"
						placeholder="Search by Name"
						className="mt-0 w-100"
						color='secondary'
						onChange={(e) => setSearch(e.target.value)}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton>
										<SearchIcon />
									</IconButton>
								</InputAdornment>
							),
							sx: {
								height: '48px',
								fontSize: '14px'
							},
						}}
					/>

					{loading &&
						<div className='my-5' style={{display:'flex' , justifyContent:'center'}}>
								<CircularProgress />
						</div>
					}

					{!loading &&
						<div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
							<TableContainer component={Paper} sx={{
								boxShadow: 'none !important',
								border: '1px solid #EAECF0',
								mt: 2
							}}>

								<Table aria-label="customized table">
									<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
										<TableRow>
											<TableCell>Name</TableCell>
											<TableCell>Availability</TableCell>
											<TableCell>Hours</TableCell>
											<TableCell>Timestamp</TableCell>
											<TableCell>Action</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{filteredEmployees?.length > 0 ? filteredEmployees?.map((row) => (
											<TableRow key={row?.fullName} sx={{
												height: '22px',
												'& .MuiTableCell-root': {
													border: 'none'
												},
												'&:nth-of-type(even)': {
													backgroundColor: 'rgba(204, 204, 204, 0.2)',
												},
											}}>

												<TableCell component="th" scope="row">
													{row?.fullName}
												</TableCell>

												<TableCell component="th" scope="row">
													{row?.Value == 'FULLTIME' ? 'Fulltime' : varFormatTime(timeFormat(row?.Start_Time), user?.Time_Format) + (' - ') + varFormatTime(timeFormat(row?.End_Time), user?.Time_Format)}
												</TableCell>

												<TableCell component="th" scope="row">
													{row?.Hours}
												</TableCell>

												<TableCell component="th" scope="row">
													{moment(row?.LogTime).format('MM/DD/YYYY, HH:mm')}
												</TableCell>

												<TableCell component="th" scope="row" align="right">
													<Row>
														<Col md={12}>
															<Chip sx={{
																height: 'auto',
																color: 'red',
																'& .MuiChip-label': {
																	display: 'block',
																	whiteSpace: 'normal',
																},
															}}
																style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer'}}
																label='Assign'
																color="red"
																onClick={() => {
																	setConfirmAssignModal(true)
																	setSelectedEmpData(row)
																}}
															/>
														</Col>

													</Row>
												</TableCell>

											</TableRow>
										))
											:
											<TableRow>
												<TableCell colSpan={6} style={{ textAlign: 'center' }}>
													No results found
												</TableCell>
											</TableRow>
										}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
					}

				</Box>
			</Modal>

			<Modal
				open={confirmAssignModal}
				onClose={() => setConfirmAssignModal(false)}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						width: '400px',
						backgroundColor: 'white',
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						padding: 4,
						borderRadius: '8px',
						boxShadow: 24,
					}}
				>
					<CloseIcon
						onClick={() => setConfirmAssignModal(false)}
						sx={{
							position: 'absolute',
							top: 20,
							right: 20,
							cursor: 'pointer',
							color: '#555',
							'&:hover': { color: '#000' },
						}}
					/>

					<div>
						<h5 className="mb-3">Are you sure to assign this shift?</h5>
					</div>

					<Row>
						<Col md="auto">
							<ButtonTheme
								type="submit"
								variant="filled"
								color="white"
								className="mt-4"
								onClick={() => setConfirmAssignModal(false)}
							>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md="auto">
							<ButtonTheme
								type="submit"
								variant="filled"
								color="primary"
								className="mt-4"
								onClick={() => assignShift(selectedEmpData)}
							>
								Assign
							</ButtonTheme>
						</Col>
					</Row>
				</Box>
			</Modal>
    </>
  );
};
